import { withStyles } from "@mui/styles";
import { Cookies } from "react-cookie";
import { useSelector } from "react-redux";
import { darkTheme, lightTheme } from "Theme";
import { rem } from "assets/js/common";

function Common(theme) {
  let palette = lightTheme.palette;

  const CommonCss = withStyles({
    "@global": {
      ".illust": {
        textAlign: "center",
        "& img": {
          verticalAlign: "top",
        },
      },

      /****************************************************
        Icon
      ****************************************************/
      "[class*='ico-']": {
        display: "inline-block",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        verticalAlign: "middle",
        width: rem(23),
        height: rem(23),
      },
      ".ico-filter": {
        // backgroundImage: `url(${
        //   process.env.PUBLIC_URL
        // }/images/icon/filter.svg)`,
        backgroundImage: `url(${
          process.env.PUBLIC_URL
        }/images/icon/dropdown-icon.svg)`,
      },
      ".ico-back": {
        backgroundImage: `url(${
          process.env.PUBLIC_URL
        }/images/icon/icon-back.svg)`,
      },
      ".ico-next": {
        backgroundImage: `url(${
          process.env.PUBLIC_URL
        }/images/icon/icon-next.svg)`,
      },
      ".ico-clock": {
        width: rem(14),
        height: rem(14),
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/icon/clock.svg)`,
      },
      ".ico-del": {
        width: rem(20),
        height: rem(20),
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/icon/del.svg)`,
      },
      ".ico-go-grey": {
        width: rem(16),
        height: rem(16),
        backgroundImage: `url(${
          process.env.PUBLIC_URL
        }/images/icon/go-grey.svg)`,
      },
      ".ico-go-black": {
        width: rem(16),
        height: rem(16),
        backgroundImage: `url(${
          process.env.PUBLIC_URL
        }/images/icon/go-black.svg)`,
      },
      ".ico-go-white": {
        width: rem(14),
        height: rem(14),
        backgroundImage: `url(${
          process.env.PUBLIC_URL
        }/images/icon/go-white.svg)`,
      },
      ".ico-go": {
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/icon/go.svg)`,
      },
      ".ico-noti": {
        marginLeft: rem(-7),
        width: rem(22),
        height: rem(22),
        backgroundImage: `url(${
          process.env.PUBLIC_URL
        }/images/icon/notice.svg)`,
      },

      /****************************************************
      Icon Button
      ****************************************************/
      ".btn-view, .btn-view-off": {
        width: rem(32),
        height: rem(32),
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",

        "& svg": {
          display: "none",
        },
      },
      ".btn-view": {
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/icon/view.svg)`,
      },
      ".btn-view-off": {
        backgroundImage: `url(${
          process.env.PUBLIC_URL
        }/images/icon/noview.svg)`,
      },

      /****************************************************
      Layout-flex
      ****************************************************/
      ".layout-flex": {
        display: "flex",
        flexDirection: "column",
        height: `calc(100vh - 52px)`,
        padding: `${rem(30)} ${rem(30)} ${rem(60)} ${rem(30)}`,
        "& .layout-body": {
          flex: 1,
        },
        "& .layout-footer": {
          marginTop: "auto",
          "& .layout-link": {
            "&::after": {
              clear: "both",
              display: "block",
              content: "''",
            },
            "& a": {
              fontSize: rem(14),
            },
            "& [class*='ico-']": {
              width: rem(16),
              height: rem(16),
            },
            "& .MuiButton-root": {
              width: "100%",
            },
            "& .left": {
              float: "left",
            },
            "& .center": {
              textAlign: "center",
            },
            "& .right": {
              float: "right",
            },
          },
        },
      },

      ".layout-flex1": {
        display: "flex",
        flexDirection: "column",
        height: `290px`,
        padding: `${rem(30)} ${rem(30)} ${rem(20)} ${rem(30)}`,
        "& .layout-body": {
          flex: 1,
        },
        "& .layout-footer": {
          marginTop: "auto",
          "& .layout-link": {
            "&::after": {
              clear: "both",
              display: "block",
              content: "''",
            },
            "& a": {
              fontSize: rem(14),
            },
            "& [class*='ico-']": {
              width: rem(16),
              height: rem(16),
            },
            "& .MuiButton-root": {
              width: "100%",
            },
            "& .left": {
              float: "left",
            },
            "& .center": {
              textAlign: "center",
            },
            "& .right": {
              float: "right",
            },
          },
        },
      },

      ".layout-flex2": {
        display: "flex",
        flexDirection: "column",
        height: `420px`,
        padding: `${rem(30)} ${rem(30)} ${rem(20)} ${rem(30)}`,
        "& .layout-body": {
          flex: 1,
        },
        "& .layout-footer": {
          marginTop: "auto",
          "& .layout-link": {
            "&::after": {
              clear: "both",
              display: "block",
              content: "''",
            },
            "& a": {
              fontSize: rem(14),
            },
            "& [class*='ico-']": {
              width: rem(16),
              height: rem(16),
            },
            "& .MuiButton-root": {
              width: "100%",
            },
            "& .left": {
              float: "left",
            },
            "& .center": {
              textAlign: "center",
            },
            "& .right": {
              float: "right",
            },
          },
        },
      },

      /****************************************************
      Nodata
      ****************************************************/
      ".nodata": {
        textAlign: "center",
        backgroundColor: "transparent",
        "& p": {
          "& + .info-txt": {
            marginTop: rem(14),
            lineHeight: rem(22),
          },
        },
        "&.mt15": {
          marginTop: "15vh",
        },
        "& .illust": {
          "& + .color-info": {
            marginTop: rem(3),
          },
        },
      },
      /****************************************************
      error page
      ****************************************************/
      ".error-page": {
        justifyContent: "space-between",
        textAlign: "center",
        backgroundColor: "transparent",
        padding: `0 ${rem(30)} ${rem(60)} ${rem(30)}`,
        "& .cont": {
          marginTop: "20vh",
          "& h3": {
            paddingTop: rem(34),
          },
          "& p": {
            paddingTop: rem(15),
          },
        },
        "& .MuiButton-root": {
          color: palette.common.white,
        },
      },
      /****************************************************
      List
      ****************************************************/
      ".list": {
        "& > li": {
          position: "relative",
          "& + li": {
            marginTop: rem(7),
          },
        },
        "&.font-14": {
          "& > li": {
            fontSize: rem(14),
          },
        },
        "&.spacing-10": {
          "& > li": {
            lineHeight: 1.5,
            // lineHeight: 1.6,
            "& + li": {
              marginTop: rem(10),
            },
            "& .list.font-14": {
              "& > li": {
                "&:before": {
                  top: rem(3),
                },
              },
            },
          },
        },

        "&-dot": {
          "& > li": {
            paddingLeft: rem(8),
            letterSpacing: "-0.5px",
            "&:before": {
              content: "''",
              position: "absolute",
              top: rem(10),
              left: 0,
              width: rem(2),
              height: rem(2),
              borderRadius: "50%",
              backgroundColor: palette.text.primary,
            },
          },
          "&.color-info": {
            "& > li:before": {
              backgroundColor: palette.info.main,
            },
          },
          "&.font-14": {
            "& > li:before": {
              top: rem(7),
            },
          },
          "&.spacing-10": {
            "& > li:before": {
              top: rem(9),
            },
          },
        },
        "&-num": {
          counterReset: "list-number",
          "& > li": {
            paddingLeft: "20px",
            counterIncrement: "list-number",

            "&:before": {
              content: "counter(list-number)'.'",
              position: "absolute",
              top: rem(1),
              left: 0,
              textIndent: "-1px",
            },
          },
          "&.list-num-round": {
            "& > li": {
              paddingLeft: rem(25),
              "&:before": {
                content: "counter(list-number)",
                top: rem(3),
                width: rem(16),
                height: rem(16),
                lineHeight: rem(18),
                border: `1px solid ${palette.text.primary}`,
                borderRadius: "50%",
                textAlign: "center",
                fontSize: rem(12),
              },
            },
            "&.font-14": {
              "& > li": {
                paddingLeft: rem(20),
                "&:before": {
                  top: rem(2),
                  width: rem(12),
                  height: rem(12),
                  lineHeight: rem(14),
                  fontSize: rem(11),
                },
              },
            },
            "&.color-info": {
              "& > li": {
                "&:before": {
                  borderColor: palette.info.main,
                },
              },
            },
          },
        },
      },

      body: {
        /****************************************************
        Icon
        ****************************************************/
        "& .MuiButton-endIcon": {
          marginLeft: rem(5),
        },

        /****************************************************
        코드관리 card
       ****************************************************/
        "& .code-box": {
          "& .tit-3": {
            marginBottom: "3px",
          },
          "& .list-scroller": {
            overflowY: "auto",
            height: rem(300),
          },
        },

        /****************************************************
        search-box
        ****************************************************/
        "& .search-box-wrap": {
          padding: `${rem(30)} ${rem(30)} ${rem(5)}`,
        },
        "& .search-box": {
          "& .MuiInputAdornment-root": {
            width: rem(24),
            height: "100%",
          },
          "& .btn-search": {
            width: rem(24),
            height: rem(24),
            backgroundImage: `url(${
              process.env.PUBLIC_URL
            }/images/icon/search.svg)`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          },
        },

        /****************************************************
        board-list
        ****************************************************/
        "& .board-list": {
          "& .item": {
            fontSize: rem(15),
            "& > a": {
              display: "block",
              padding: `${rem(25)} ${rem(30)}`,
            },
            "& .title": {},
            "&:first-of-type > a": {
              paddingTop: 0,
            },
            "& + .item": {
              borderTop: "1px solid",
              borderTopColor: palette.info.light,
            },
            "&.MuiAccordion-root": {
              boxShadow: "none",
              "&:before": {
                display: "none",
              },
            },
          },
          "&-faq": {
            "& .MuiAccordionSummary-root": {
              padding: 0,
            },
            "& .MuiAccordionSummary-content": {
              position: "relative",
              padding: `${rem(25)} ${rem(55)} ${rem(25)} ${rem(52)}`,
              margin: 0,
              "&::before": {
                content: "'Q'",
                position: "absolute",
                top: rem(25),
                left: rem(30),
                fontWeight: 800,
              },
              "&::after": {
                content: "''",
                position: "absolute",
                top: "50%",
                right: rem(30),
                width: rem(18),
                height: rem(18),
                marginTop: rem(-9),
                backgroundImage: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/arrow-b-gray.svg)`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                transition: "all ease 0.5s",
              },
              "& > p": {
                minHeight: rem(22),
              },
            },
            "& .MuiAccordionDetails-root": {
              position: "relative",
              padding: `${rem(25)} ${rem(30)} ${rem(25)} ${rem(52)}`,
              backgroundColor: "#F6F6F6",
              "&::before": {
                content: "'A'",
                position: "absolute",
                top: rem(25),
                left: rem(30),
                color: palette.primary.main,
                fontWeight: 800,
              },
              "& > p": {
                minHeight: rem(22),
              },
            },
            "& .Mui-expanded": {
              margin: 0,
              "& .MuiAccordionSummary-content": {
                fontWeight: 700,
                "&::before": {
                  color: palette.primary.main,
                },
                "&::after": {
                  transform: "rotate(180deg)",
                },
              },
            },
          },
          "&-floor": {
            paddingBottom: rem(30),
            "& .MuiAccordionSummary-root": {
              padding: 0,
            },
            "& .MuiAccordionSummary-content": {
              position: "relative",
              padding: `${rem(25)} ${rem(55)} ${rem(25)} ${rem(59)}`,
              margin: 0,
              minHeight: rem(68),
              "&::before": {
                content: "''",
                position: "absolute",
                top: rem(25),
                left: rem(30),
                fontWeight: 800,
              },
              "&::after": {
                content: "''",
                position: "absolute",
                top: "50%",
                right: rem(30),
                width: rem(18),
                height: rem(18),
                marginTop: rem(-9),
                backgroundImage: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/arrow-b-gray.svg)`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                transition: "all ease 0.5s",
              },
              "& .tit": {
                fontSize: rem(15),
              },
              "& .floor-num": {
                position: "absolute",
                left: rem(30),
                fontWeight: 800,
              },
            },
            "& .MuiAccordionDetails-root": {
              position: "relative",
              padding: `${rem(6)} ${rem(30)} ${rem(25)} ${rem(59)}`,
              "&::before": {
                content: "",
                position: "absolute",
                top: rem(25),
                left: rem(30),
                color: palette.primary.main,
                fontWeight: 800,
              },
              "& .floor-item": {
                "& > p": {
                  fontSize: rem(14),
                  fontWeight: 700,
                  lineHeight: rem(22),
                },
                "& .board-info": {
                  fontSize: rem(14),
                  lineHeight: rem(22),
                },
                "& + .floor-item": {
                  paddingTop: rem(24),
                },
                "& .board-info span": {
                  "& + span": {
                    paddingLeft: rem(12),
                    marginLeft: rem(12),
                  },
                },
              },
            },
            "& .Mui-expanded": {
              margin: 0,
              "& .MuiAccordionSummary-content": {
                fontWeight: 700,
                "& .tit": {
                  fontWeight: 400,
                },
                "&::before": {
                  color: palette.primary.main,
                },
                "&::after": {
                  transform: "rotate(180deg)",
                },
              },
            },
          },
        },
        "& .board-info": {
          marginTop: rem(2),
          fontSize: rem(12),
          color: palette.info.main,
          "& > span": {
            display: "inline-block",
            position: "relative",
            "& + span": {
              paddingLeft: rem(8),
              marginLeft: rem(8),
              "&::before": {
                content: "''",
                position: "absolute",
                top: "50%",
                left: 0,
                transform: "translateY(-50%)",
                height: "50%",
                width: "1px",
                backgroundColor: palette.info.light,
              },
            },
          },
        },
        "& .board-cont": {
          fontSize: rem(14),
          fontWeight: 400,
        },
        "& .board-file": {
          marginTop: rem(40),
          fontSize: rem(14),
          color: palette.info.main,
          display: "flex",
          "& .title span": {
            position: "relative",
            display: "block",
            paddingLeft: rem(22),
            paddingRight: rem(10),
            marginRight: rem(10),
            "&::before": {
              content: "''",
              position: "absolute",
              top: "50%",
              left: 0,
              transform: "translateY(-50%)",
              width: rem(22),
              height: rem(22),
              backgroundImage: `url(${
                process.env.PUBLIC_URL
              }/images/icon/file.svg)`,
              backgroundRepeat: "no-repeat",
            },
            "&::after": {
              content: "''",
              position: "absolute",
              top: "50%",
              right: 0,
              transform: "translateY(-50%)",
              height: "70%",
              width: "1px",
              backgroundColor: palette.info.light,
            },
          },
          "& .names": {
            flex: 1,
            "& .name": {
              display: "block",
              "& a": {
                display: "inline-block",
                color: palette.info.main,
                borderBottom: `1px ${palette.info.main} solid`,
                lineHeight: 1.1,
              },
              "& .size": {
                display: "inline-block",
                marginLeft: rem(5),
                color: palette.grey[300],
                fontSize: rem(12),
              },
            },
          },
        },

        /****************************************************
        trust
        ****************************************************/
        "& #trustDetail": {
          "& .drawer-head": {
            padding: `${rem(40)} ${rem(35)} ${rem(30)}`,
            borderBottom: "none",
            "& h3": {
              fontSize: rem(18),
              fontWeight: 800,
            },
          },
        },

        /****************************************************
        form-group-wrap
        ****************************************************/
        "& .form-group-wrap": {
          marginTop: rem(-16),
          "& > .MuiGrid-item": {
            paddingTop: rem(16),
          },
          "& .inner-grid": {
            // marginTop: rem(-10),
            "& > .MuiGrid-item": {
              paddingTop: rem(10),
            },
          },
          "& .item-grid": {
            alignItems: "center",
            "-webkit-align-items": "center",
            "& .MuiButton-root": {
              padding: 0,
              width: "100%",
            },
          },
        },

        /****************************************************
        Notice
        ****************************************************/
        "& .notice": {
          "& .title": {
            fontSize: rem(14),
            fontWeight: 700,
          },
          "& .list": {
            marginTop: rem(15),
            "& > li": {
              marginTop: rem(7),
            },
          },
          "&.is-bottom": {
            padding: `${rem(30)} ${rem(30)} ${rem(60)}`,
            marginTop: "auto",
            backgroundColor: palette.background.paper,
          },
          "&.bg-grey": {
            backgroundColor: palette.background.default,
          },
          "& .MuiPaper-root": {
            boxShadow: "none",
            "& .MuiButtonBase-root": {
              minHeight: "auto",
              padding: 0,
              "&:after": {
                content: "''",
                width: rem(22),
                height: rem(22),
                backgroundImage: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/dropdown.svg)`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              },
              "&.Mui-expanded": {
                "&:after": {
                  transform: "rotate(180deg)",
                },
              },
            },
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
            "& .MuiAccordionDetails-root": {
              padding: 0,
            },
          },
        },

        /****************************************************
        login-body
        ****************************************************/
        "& .login-body": {
          paddingTop: rem(50),
          "& .text-top": {
            textAlign: "center",
            fontSize: rem(18),
          },
          "& .stepper-cont": {
            margin: "0 auto",
            width: rem(207),
          },
          "& .stepper-pw": {
            position: "relative",
            margin: `${rem(30)} 0 ${rem(35)}`,
            "& .MuiPaper-root": {
              padding: 0,
            },
            "& .MuiStepper-root": {
              width: "100%",
              height: rem(22),
              justifyContent: "space-between",
              // gap: rem(15),
              "& .MuiStep-root": {
                width: rem(22),
                height: rem(22),
                padding: 0,
                backgroundColor: palette.grey[200],
                borderRadius: "50%",
                "&.Mui-completed": {
                  backgroundColor: "#000",
                },
                "& + .MuiStep-root": {
                  marginLeft: rem(15),
                },
              },
            },
            "& .ghost-input": {
              position: "absolute",
              top: "50%",
              left: 0,
              transform: "translateY(-50%)",
              width: "100%",
              height: rem(30),
              border: "none",
              backgroundColor: "transparent",
              outline: "none",
              color: "transparent",
              caretColor: "transparent",
              fontSize: 0,
            },
          },
          "& .info-txt": {
            textAlign: "center",
          },
          "& .MuiFormControlLabel-label": {
            color: palette.text.disabled,
          },
          "& .Mui-checked + .MuiFormControlLabel-label": {
            color: "#000",
          },
        },
        "& .simple-drawer": {
          "& .info": {
            padding: `${rem(45)} 0`,
            "& .text": {
              "& strong": {
                fontSize: rem(18),
                lineHeight: rem(24),
                fontWeight: 700,
              },
              "& div": {
                fontSize: rem(14),
                lineHeight: rem(22),
                color: palette.info.main,
                marginTop: rem(10),
                "& p": {
                  "& + p": {
                    marginTop: rem(12),
                  },
                },
              },
            },
          },
        },
        /****************************************************
        이용약관 & 개인정보 수집 및 이용
        ****************************************************/
        "& .policy-wrap": {
          fontSize: rem(14),
          "& h3": {
            marginBottom: rem(30),
            "&:not(:first-of-type)": {
              marginTop: rem(50),
            },
          },
          "& h4": {
            marginBottom: rem(12),
            "&:not(:first-of-type)": {
              marginTop: rem(30),
            },
          },
          "& p": {
            lineHeight: "1.6",
            letterSpacing: "-0.5px",
            fontSize: rem(14),
          },
          "& .list": {
            "& li": {
              lineHeight: "1.6",
            },
            "&.list-num-round": {
              "&.font-14": {
                "& > li": {
                  "&:before": {
                    top: rem(3),
                  },
                },
              },
            },
          },
        },

        /****************************************************
        stamp
        ****************************************************/
        // "& .stamp-grid": {
        //   // padding: `${rem(23)} ${rem(30)} ${rem(30)} ${rem(26)}`,
        //   // borderRadius: rem(10),
        //   // backgroundColor: palette.common.white,
        //   "& .on": {
        //     "& .stamp": {
        //       overflow: "hidden",
        //       position: "relative",
        //       maxWidth: rem(54),
        //       maxHeight: rem(54),
        //       borderRadius: "50%",
        //       // backgroundColor: palette.info.light,
        //       backgroundImage: `url(${
        //         process.env.PUBLIC_URL
        //       }/images/icon/stamp-on.svg)`,
        //       backgroundRepeat: "no-repeat",
        //       backgroundSize: "100%",
        //       "& img": {
        //         width: "100%",
        //       },
        //     },
        //     "& .benefit": {
        //       position: "absolute",
        //       display: "flex",
        //       alignItems: "center",
        //       justifyContent: "center",
        //       top: "50%",
        //       left: "50%",
        //       transform: "rotateZ(-15deg) translate(-50% , -50%)",
        //       border: `1px solid ${palette.primary.main}`,
        //       borderRadius: rem(6),
        //       lineHeight: 1,
        //       color: `${palette.primary.main}`,
        //       fontSize: rem(14),
        //       fontWeight: 800,
        //       backgroundColor: palette.common.white,
        //       minWidth: rem(60),
        //       minHeight: rem(23),
        //       margin: `${rem(9)} 0 0 ${rem(5)}`,
        //     },
        //   },
        //   "& .MuiGrid-item": {
        //     flexBasis: "20%",
        //     display: "flex",
        //     alignItems: "center",
        //     justifyContent: "center",
        //     position: "relative",
        //     padding: `${rem(18)} 0 0 ${rem(10)}`,
        //     "& .stamp": {
        //       overflow: "hidden",
        //       position: "relative",
        //       width: rem(54),
        //       height: rem(54),
        //       borderRadius: "50%",
        //       // backgroundColor: palette.info.light,
        //       backgroundImage: `url(${
        //         process.env.PUBLIC_URL
        //       }/images/icon/stamp-off.svg)`,
        //       backgroundRepeat: "no-repeat",
        //       backgroundSize: "100%",
        //       "&.on": {
        //         backgroundImage: `url(${
        //           process.env.PUBLIC_URL
        //         }/images/icon/stamp-on.svg)`,
        //       },
        //       "& img": {
        //         width: "100%",
        //       },
        //     },
        //     "& .benefit": {
        //       position: "absolute",
        //       display: "flex",
        //       alignItems: "center",
        //       justifyContent: "center",
        //       top: "50%",
        //       left: "50%",
        //       transform: "translate(-50% , -50%)",
        //       backgroundColor: "#CCCCCC",
        //       borderRadius: rem(6),
        //       lineHeight: 1,
        //       color: "#F6F6F6",
        //       fontSize: rem(14),
        //       fontWeight: 800,
        //       minWidth: rem(60),
        //       minHeight: rem(23),
        //       margin: `${rem(9)} 0 0 ${rem(5)}`,
        //     },
        //     "& .date": {
        //       position: "absolute",
        //       fontSize: rem(18),
        //       fontWeight: 800,
        //       color: "#DFDFDF",
        //       lineHeight: rem(62),
        //     },
        //   },
        // },
        // "& .stamp-bg-grid": {
        //   padding: `${rem(23)} ${rem(30)} ${rem(30)} ${rem(26)}`,
        //   borderRadius: rem(10),
        //   backgroundColor: palette.common.white,
        //   "& .on": {
        //     "& .stamp": {
        //       overflow: "hidden",
        //       position: "relative",
        //       maxWidth: rem(62),
        //       maxHeight: rem(62),
        //       borderRadius: "50%",
        //       // backgroundColor: palette.info.light,
        //       backgroundImage: `url(${
        //         process.env.PUBLIC_URL
        //       }/images/icon/stamp-on.svg)`,
        //       backgroundRepeat: "no-repeat",
        //       backgroundSize: "100%",
        //       "& img": {
        //         width: "100%",
        //       },
        //     },
        //     "& .benefit": {
        //       position: "absolute",
        //       display: "flex",
        //       alignItems: "center",
        //       justifyContent: "center",
        //       top: "42%",
        //       left: "54%",
        //       transform: "rotateZ(-15deg) translate(-47% , -46%)",
        //       border: `1px solid ${palette.primary.main}`,
        //       borderRadius: rem(6),
        //       lineHeight: 1,
        //       color: `${palette.primary.main}`,
        //       fontSize: rem(14),
        //       fontWeight: 800,
        //       backgroundColor: palette.common.white,
        //       minWidth: rem(60),
        //       minHeight: rem(23),
        //     },
        //   },
        //   "& .MuiGrid-item": {
        //     flexBasis: "20%",
        //     display: "flex",
        //     alignItems: "center",
        //     justifyContent: "center",
        //     position: "relative",
        //     padding: `${rem(7)} 0 0 ${rem(4)}`,
        //     "& .stamp": {
        //       overflow: "hidden",
        //       position: "relative",
        //       width: rem(62),
        //       height: rem(62),
        //       borderRadius: "50%",
        //       // backgroundColor: palette.info.light,
        //       backgroundImage: `url(${
        //         process.env.PUBLIC_URL
        //       }/images/icon/stamp-off.svg)`,
        //       backgroundRepeat: "no-repeat",
        //       backgroundSize: "100%",
        //       "&.on": {
        //         backgroundImage: `url(${
        //           process.env.PUBLIC_URL
        //         }/images/icon/stamp-on.svg)`,
        //       },
        //       "& img": {
        //         width: "100%",
        //       },
        //     },
        //     "& .benefit": {
        //       position: "absolute",
        //       display: "flex",
        //       alignItems: "center",
        //       justifyContent: "center",
        //       top: "53%",
        //       left: "51%",
        //       transform: "translate(-49% , -47%)",
        //       backgroundColor: "#CCCCCC",
        //       borderRadius: rem(6),
        //       lineHeight: 1,
        //       color: "#F6F6F6",
        //       fontSize: rem(14),
        //       fontWeight: 800,
        //       minWidth: rem(60),
        //       minHeight: rem(23),
        //     },
        //     "& .date": {
        //       position: "absolute",
        //       fontSize: rem(18),
        //       fontWeight: 800,
        //       color: "#DFDFDF",
        //       lineHeight: rem(62),
        //     },
        //   },
        // },

        /****************************************************
        event
        ****************************************************/
        "& .event-drawer": {
          "& .drawer-head": {
            border: "none !important",
            "& h3": {
              textAlign: "center",
            },
          },
          "& .drawer-body": {
            "& .tit": {
              // paddingTop: rem(20),
              fontWeight: 700,
            },
            "& .sub-tit": {
              paddingTop: rem(6),
              fontSize: rem(14),
              color: palette.text.disabled,
            },
            "& .date": {
              paddingTop: rem(7),
              fontSize: rem(12),
              color: palette.text.disabled,
            },
            "& .board-info": {
              marginTop: rem(7),
            },
          },
        },

        "& .fav-comment": {
          "& .MuiTextField-root": {
            height: rem(310),
            "& .MuiInputBase-multiline": {
              height: "100%",
              "& textarea": {
                height: "100%",
              },
            },
          },
        },

        /****************************************************
        receipt
        ****************************************************/
        "& .receipt-select": {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          padding: `${rem(40)} ${rem(30)} ${rem(40)} ${rem(40)}`,
          "& dl": {
            "& dt": {
              fontWeight: 800,
              marginBottom: rem(10),
            },
            "& dd": {
              fontSize: rem(13),
              color: palette.info.main,
              lineHeight: rem(20),
            },
          },
          "& .MuiSwitch-root": {
            width: rem(95),
            height: rem(30),
            padding: 0,
            alignItems: "center",
            justifyContent: "center",
            overflow: "visible",
            background: palette.common.white,
            borderRadius: rem(22),
            "& .MuiSwitch-track": {
              position: "relative",
              backgroundColor: "#fff",
              border: "none",
              boxShadow: "none",
              borderRadius: rem(22),
              "&:before, &:after": {
                position: "absolute",
                top: rem(6),
                fontSize: rem(13),
                letterSpacing: "-0.2px",
                fontWeight: 700,
                color: palette.text.disabled,
              },
              "&:before": {
                content: "'OFF'",
                left: rem(13),
              },
              "&:after": {
                content: "'ON'",
                right: rem(14),
              },
            },
            "& .MuiSwitch-switchBase": {
              padding: 0,
              "& .MuiSwitch-thumb": {
                position: "relative",
                background: "#9e9e9e",
                width: rem(47),
                height: rem(30),
                margin: 0,
                boxShadow: "0 2px 2px rgba(158, 158, 158, 0.3)",
                borderRadius: rem(22),
                "&:after": {
                  position: "absolute",
                  top: rem(6),
                  fontSize: rem(13),
                  letterSpacing: "-0.2px",
                  fontWeight: 700,
                  color: palette.common.white,
                  content: "'OFF'",
                  right: rem(14),
                },
              },
              "& + .MuiSwitch-track": {
                opacity: 1,
                background: palette.common.white,
              },
              "&.Mui-checked": {
                transform: "translateX(49px)",
                "& .MuiSwitch-thumb": {
                  background: palette.primary.main,
                  "&:after": {
                    content: "'ON'",
                  },
                },
                "& + .MuiSwitch-track": {
                  background: palette.common.white,
                },
                "& .MuiSwitch-input": {
                  left: "-100%",
                },
              },
            },
          },
          "& .MuiSwitch-input": {
            width: "200%",
            left: 0,
          },
        },
        "& .receipt-month": {
          padding: `${rem(35)} 0 ${rem(40)}`,
          "& .select-month": {
            display: "block",
            textAlign: "center",
            fontSize: rem(24),
            letterSpacing: "-0.2px",
            lineHeight: rem(30),
            fontWeight: 800,
          },
          "& .MuiTabs-root": {
            margin: `${rem(12)} 0 ${rem(30)}`,
            "& .MuiTabs-scroller": {
              borderBottom: "none",
              padding: 0,
              "& .MuiTabs-flexContainer": {
                justifyContent: "center",
                "& .MuiButtonBase-root": {
                  color: palette.info.main,
                  "& .month": {
                    fontSize: rem(12),
                    fontWeight: 700,
                    "& b": {
                      display: "block",
                      fontSize: rem(15),
                      fontWeight: 800,
                      marginTop: rem(3),
                      lineHeight: rem(20),
                    },
                  },
                },
                "& .Mui-selected": {
                  color: palette.common.black,
                },
              },
              "& .MuiTabs-indicator": {
                display: "flex",
                justifyContent: "center",
                backgroundColor: "transparent",
                height: rem(4),
                bottom: rem(0),
                "& > span": {
                  width: rem(4),
                  height: rem(4),
                  backgroundColor: palette.primary.main,
                  borderRadius: "50%",
                },
              },
            },
            "& .MuiButtonBase-root": {
              margin: `0 ${rem(9)}`,
              letterSpacing: "-0.2px",
              minHeight: "auto",
              padding: `0 0 ${rem(6)} 0`,
            },
          },
          "& .tabpanel": {
            margin: `${rem(25)} 0 ${rem(40)}`,
          },
          "& .receipt-list": {
            "& li": {
              position: "relative",
              borderTop: `1px solid ${palette.grey[100]}`,
              padding: `${rem(20)} ${rem(50)} ${rem(20)} ${rem(65)}`,
              "& a": {
                color: palette.text.primary,
                textDecoration: "none",
                display: "flex",
                justifyContent: "space-between",
                "& .title-group": {
                  height: rem(42),
                  "& .store": {
                    fontSize: rem(15),
                    lineHeight: rem(20),
                  },
                  "& .date": {
                    fontSize: rem(12),
                    lineHeight: rem(18),
                    color: palette.info.main,
                    letterSpacing: "-0.2px",
                  },
                },
                "& .price": {
                  letterSpacing: "-0.2px",
                  fontWeight: 700,
                  lineHeight: rem(22),
                },
              },
              "&::after": {
                content: "''",
                position: "absolute",
                top: "50%",
                right: rem(25),
                width: rem(20),
                height: rem(20),
                marginTop: rem(-11),
                backgroundImage: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/arrow-r-gray.svg)`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: `${rem(20)} ${rem(20)}`,
              },
              "&::before": {
                content: "''",
                position: "absolute",
                top: rem(20),
                left: rem(30),
                width: rem(20),
                height: rem(20),
              },
              "&.mall::before": {
                backgroundImage: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/icon-mall.svg)`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              },
              "&.mart::before": {
                backgroundImage: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/icon-mart.svg)`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              },
            },
          },
          "& .btn-wrap": {
            padding: `0 ${rem(30)}`,
          },
        },
        "& .point-save": {
          "& form": {
            display: "flex",
            flexDirection: "column",
            height: "calc(100vh - 52px)",
          },
          "& .drawer-head": {
            border: "none !important",
          },
          "& .drawer-body": {
            "& .save-info": {
              position: "relative",
              color: palette.primary.main,
              fontSize: rem(14),
              lineHeight: rem(22),
              paddingLeft: rem(24),
              marginTop: rem(20),
              "&:before": {
                content: "''",
                width: rem(22),
                height: rem(22),
                backgroundImage: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/icon-info.svg)`,
                position: "absolute",
                top: 0,
                left: 0,
              },
            },
          },
        },
        "& .receipt": {
          "& li": {
            "& a": {
              color: palette.text.primary,
              textDecoration: "none",
              position: "relative",
              "& .tit": {
                fontWeight: "700",
                fontSize: "14px",
              },
            },
            "&::after": {
              position: "absolute",
              width: rem(20),
              height: rem(18),
              top: rem(480),
              left: rem(70),
              content: "''",
              backgroundImage: `url(${
                process.env.PUBLIC_URL
              }/images/icon/arrow-r-gray.svg)`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: `${rem(20)} ${rem(20)}`,
            },
          },
        },
        "& .regularstore": {
          marginTop: rem(30),
          "& .namebox": {
            marginLeft: rem(30),
            fontSize: rem(18),
            "& b": {
              fontWeight: "800",
            },
          },
          "& .storebox": {
            margin: `${rem(10)} ${rem(20)} 0`,
            "& .mySwiper": {
              paddingBottom: 0,
            },
            "& a": {
              width: "100%",
              "& .storebox-banner": {
                width: "100%",
                height: rem(134),
                padding: `0 ${rem(30)}`,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderRadius: rem(10),
                "&.graybox": {
                  backgroundColor: "#F6F6F6",
                  color: palette.common.black,
                  "& .boxtext": {
                    "& .mega-store": {
                      "&::after": {
                        backgroundImage: `url(${
                          process.env.PUBLIC_URL
                        }/images/icon/arrow-r-gray.svg)`,
                      },
                    },
                  },
                },
                "&.redbox": {
                  backgroundColor: "#F1270B",
                  color: palette.common.white,
                  "& .boxtext": {
                    "& .mega-store": {
                      "&::after": {
                        backgroundImage: `url(${
                          process.env.PUBLIC_URL
                        }/images/icon/arrow-r-red.svg)`,
                      },
                    },
                  },
                },
                "& .boxtext": {
                  "& .tit": {
                    fontSize: rem(14),
                    lineHeignt: rem(22),
                  },
                  "& .mega-store": {
                    position: "relative",
                    fontWeight: "700",
                    fontSize: rem(18),
                    lineHeight: rem(24),
                    marginTop: rem(2),
                    "&::after": {
                      content: "''",
                      position: "absolute",
                      top: "50%",
                      marginTop: rem(-11),
                      width: rem(22),
                      height: rem(22),
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                    },
                  },
                  "& .time": {
                    fontSize: "13px",
                    color: "#FFFFFF",
                    marginTop: "20px",
                    "& b": {
                      fontWeight: 700,
                      marginRight: rem(6),
                    },
                  },
                },
                "& .illust": {
                  display: "flex",
                  alignItems: "center",
                },
              },
            },
          },
          "& .cpbox": {
            margin: `${rem(30)} ${rem(20)}`,
            display: "flex",
            justifyContent: "space-around",
            "& a": {
              width: "100%",
              justifyContent: "center",
              flexDirection: "column",
            },
            "& .coupon, .point": {
              textAlign: "center",
              width: "50%",
              "& .p1": {
                marginTop: rem(4),
                fontSize: rem(12),
                lineHeight: rem(18),
              },
              "& .p2": {
                marginTop: rem(6),
                lineHeight: rem(22),
                "& b": {
                  fontWeight: "800",
                },
              },
            },
            "& .coupon": {
              position: "relative",
              "&:after": {
                content: "''",
                display: "block",
                width: "1px",
                height: "20px",
                background: "#eee",
                position: "absolute",
                top: "50%",
                right: 0,
                marginTop: "-10px",
              },
            },
          },
        },
        "& .my-receipt": {
          padding: `${rem(40)} ${rem(30)} 0`,
          "& .receipt-link": {
            "& h3": {
              position: "relative",
              fontSize: rem(14),
              fontWeight: 700,
              lineHeight: rem(22),
              paddingRight: rem(20),
              "&::after": {
                content: "''",
                position: "absolute",
                top: "50%",
                right: 0,
                width: rem(18),
                height: rem(18),
                marginTop: rem(-10),
                backgroundImage: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/arrow-r-gray.svg)`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: `${rem(18)} ${rem(18)}`,
              },
            },
          },
        },

        /****************************************************
        product of week
        ****************************************************/
        //list
        "& .productOfWeek": {
          "& .banner": {
            position: "relative",
            "& .banner-img": {
              height: rem(211),
            },
            "& img": {
              width: "100%",
              height: rem(211),
              objectFit: "cover",
            },
            "& button": {
              position: "absolute",
              left: rem(30),
              top: rem(137),
              height: rem(28),
              padding: `0 ${rem(10)} 0 ${rem(14)}`,
              fontSize: rem(12),
              border: `1px solid #FFFFFF`,
              "& .MuiButton-endIcon": {
                marginLeft: 0,
              },
              "&:hover": {
                backgroundColor: palette.primary.main,
              },
            },
          },
          "& .best-items": {
            padding: `${rem(40)} ${rem(30)} ${rem(10)}`,
            "& .sub-txt": {
              color: "#8E8E8E",
              fontSize: rem(14),
              marginTop: rem(5),
              marginBottom: rem(30),
            },
          },
          "& .catg-items": {
            //   padding: `${rem(60)} ${rem(30)} ${rem(50)} ${rem(30)}`,
            padding: `${rem(60)} 0 ${rem(30)}`,
            "& h3": {
              paddingLeft: rem(30),
            },
          },
        },
        //best items
        "& .bestItems": {
          width: `calc(100% + ${rem(15)})`,
          marginLeft: rem(-15),
          "& .list-wrap": {
            display: "flex",
            flexWrap: "wrap",
          },
          "& .item": {
            width: `calc(50% - ${rem(15)})`,
            paddingBottom: rem(50),
            alignItems: "center",
            boxSizing: "border-box",
            marginLeft: rem(15),
            "& .item-img": {
              position: "relative",
              paddingTop: "100%",
              background: "#fff",
              borderRadius: rem(10),
              "& .img-wrap": {
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                margin: "auto",
                maxWidth: "85%",
                maxHeight: "85%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& img": {
                  maxWidth: "100%",
                  maxHeight: "100%",
                },
              },
              "& .badge": {
                display: "block",
                position: "absolute",
                top: rem(-4),
                right: rem(-4),
                width: rem(34),
                height: rem(34),
                backgroundColor: "#000000",
                borderRadius: "50%",
                "& .txt": {
                  display: "flex",
                  fontSize: rem(9),
                  color: "#FFFFFF",
                  margin: "auto",
                  lineHeight: 1,
                  alignItems: "center",
                  justifyContent: "center",
                  width: rem(34),
                  height: rem(34),
                  textAlign: "center",
                },
              },
            },
            "& .tit": {
              fontWeight: 700,
              fontSize: rem(14),
              paddingTop: rem(15),
              lineHeight: rem(20),
              overflow: "hidden",
              textOverflow: "ellipsis",
              wordWrap: "break-word",
              display: "-webkit-box",
              "-webkit-line-clamp": 2,
              "-webkit-box-orient": "vertical",
            },
            "& .sub-tit": {
              fontSize: rem(12),
              paddingTop: rem(8),
              lineHeight: rem(16),
            },
            "& .price": {
              display: "flex",
              alignItems: "center",
              margin: `${rem(4)} 0`,
              fontWeight: 800,
              fontSize: rem(18),
              lineHeight: rem(24),
              "& span": {
                fontWeight: 700,
                fontSize: rem(14),
                padding: `0 0 ${rem(1)} ${rem(1)}`,
              },
            },

            "& .grey-box": {
              display: "inline-block",
              height: rem(20),
              lineHeight: rem(20),
              color: "#8E8E8E",
              fontSize: rem(11),
              padding: `0 ${rem(6)}`,
              border: "1px solid #8E8E8E",
              borderRadius: rem(2),
              margin: `0 ${rem(4)} 0 0`,
            },
            "& .red-box": {
              display: "inline-block",
              height: rem(20),
              lineHeight: rem(20),
              color: "#F1270B",
              fontSize: rem(11),
              padding: `0 ${rem(6)}`,
              border: "1px solid #F1270B",
              borderRadius: rem(2),
              margin: `0 ${rem(4)} 0 0`,
            },

            "& .cnt": {
              fontSize: rem(11),
              marginTop: rem(8),
              lineHeight: rem(14),
            },
          },
          "& .func-btn": {
            marginTop: rem(10),
            "& .MuiButton-root": {
              minWidth: "auto",
              fontSize: rem(13),
              "& img": {
                width: rem(24),
                height: rem(24),
              },
              "& span": {
                fontWeight: 800,
              },
              "& + .MuiButton-root": {
                marginLeft: rem(20),
              },
            },
          },
        },
        //category items
        "& .categoryItems": {
          "& .header": {
            //   margin: `0 ${rem(-30)}`,
            "& .MuiTabs-root": {
              marginTop: rem(8),
            },
            "& .func-wrap": {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: `${rem(20)} ${rem(30)} ${rem(12)} ${rem(30)}`,
              "& .cnt": {
                fontSize: rem(14),
                color: "#8E8E8E",
                fontWeight: 700,
              },
              "& .sort": { fontSize: rem(13) },
            },
            "& .divider": {
              height: rem(8),
              backgroundColor: "#F6F6F6",
            },
          },
          "& .list-wrap": {
            "& .MuiGrid-root + .MuiGrid-root": {
              borderTop: `8px solid #F6F6F6`,
            },
            "& .item": {
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              padding: `${rem(30)} ${rem(20)}`,
              "& .item-img": {
                position: "relative",
                width: rem(130),
                height: rem(110),
                background: "transparent",
                "& .img-wrap": {
                  position: "absolute",
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                  margin: "auto",
                  maxWidth: "85%",
                  maxHeight: "85%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "& img": {
                    maxWidth: "100%",
                    maxHeight: "100%",
                  },
                },
                "& .badge": {
                  display: "block",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: rem(34),
                  height: rem(34),
                  backgroundColor: "#000000",
                  borderRadius: "50%",
                  "& .txt": {
                    display: "flex",
                    fontSize: rem(9),
                    color: "#FFFFFF",
                    margin: "auto",
                    lineHeight: 1,
                    alignItems: "center",
                    justifyContent: "center",
                    width: rem(34),
                    height: rem(34),
                    textAlign: "center",
                  },
                },
              },
              "& .contents-wrap": {
                flex: 1,
                paddingLeft: rem(20),
                "& .tit": {
                  fontWeight: 700,
                  fontSize: rem(14),
                  lineHeight: 1,
                  paddingBottom: rem(8),
                },
                "& .sub-tit": {
                  fontSize: rem(12),
                },
                "& .price": {
                  display: "flex",
                  alignItems: "center",
                  paddingTop: rem(4),
                  fontWeight: 800,
                  fontSize: rem(18),
                  lineHeight: 1,
                  "& span": {
                    fontWeight: 700,
                    fontSize: rem(14),
                    padding: `0 0 ${rem(2)} ${rem(1)}`,
                  },
                  "& +.grey-box, +.red-box": {
                    marginTop: rem(8),
                  },
                },
                "& .grey-box": {
                  display: "inline-block",
                  height: rem(20),
                  lineHeight: rem(20),
                  color: "#8E8E8E",
                  fontSize: rem(11),
                  padding: `0 ${rem(6)}`,
                  border: "1px solid #8E8E8E",
                  borderRadius: rem(2),
                  marginRight: rem(4),
                  margin: `0 ${rem(4)} 0 0`,
                },
                "& .red-box": {
                  display: "inline-block",
                  height: rem(20),
                  lineHeight: rem(20),
                  color: "#F1270B",
                  fontSize: rem(11),
                  padding: `0 ${rem(6)}`,
                  border: "1px solid #F1270B",
                  borderRadius: rem(2),
                  margin: `0 ${rem(4)} 0 0`,
                },
                "& .cnt": {
                  fontSize: rem(11),
                  marginTop: rem(8),
                },
                "& .func-btn": {
                  position: "relative",
                  marginTop: rem(12),
                  height: rem(24),
                  zIndex: "1",
                  "& .MuiButton-root": {
                    minWidth: "auto",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    zIndex: "10",
                  },
                },
              },
            },
          },
        },
        //detail
        "& .productOfWeekDetail": {
          "& .product-info": {
            padding: `${rem(20)} ${rem(20)} ${rem(40)}`,
            borderBottom: `1px solid #EEEEEE`,
            "& .product-img": {
              position: "relative",
              paddingTop: "100%",
              border: `1px solid #DFDFDF`,
              borderRadius: rem(10),
              width: "100%",
              "& .img-wrap": {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                margin: "auto",
                display: "flex",
                position: "absolute",
                maxWidth: "60%",
                maxHeight: "60%",
                alignItems: "center",
                justifyContent: "center",
                "& img": {
                  maxWidth: "100%",
                  maxHeight: "100%",
                },
              },
              "& .badge": {
                display: "block",
                position: "absolute",
                top: rem(15),
                left: rem(15),
                width: rem(40),
                height: rem(40),
                backgroundColor: "#000000",
                borderRadius: "50%",
                "& .txt": {
                  display: "flex",
                  color: "#FFFFFF",
                  margin: "auto",
                  lineHeight: 1,
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: rem(11),
                  width: rem(40),
                  height: rem(40),
                  textAlign: "center",
                },
              },
            },
            "& .txt-wrap": {
              padding: `0 ${rem(10)}`,
              "& .tit": {
                fontWeight: 700,
                fontSize: rem(16),
                paddingTop: rem(30),
              },
              "& .sub-tit": {
                fontSize: rem(14),
                paddingTop: rem(12),
              },
              "& .price-wrap": {
                display: "flex",
                alignItems: "center",
                padding: `${rem(8)} 0 ${rem(12)}`,
                "& .price": {
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 800,
                  fontSize: rem(22),
                  lineHeight: rem(28),
                  "& span": {
                    fontWeight: 700,
                    fontSize: rem(18),
                    padding: `0 0 ${rem(1)} ${rem(1)}`,
                  },
                },
                "& .price-before": {
                  color: "#BEBEBE",
                  textDecorationLine: "line-through",
                  paddingLeft: rem(8),
                  letterSpacing: "-0.2px",
                },
              },
              "& .grey-box": {
                display: "inline",
                color: "#8E8E8E",
                fontSize: rem(13),
                padding: `${rem(3)} ${rem(6)}`,
                border: "1px solid #8E8E8E",
                borderRadius: rem(2),
                "& + .red-box": {
                  marginLeft: rem(5),
                },
              },
              "& .red-box": {
                display: "inline",
                color: "#F1270B",
                fontSize: rem(13),
                padding: `${rem(3)} ${rem(6)}`,
                border: "1px solid #F1270B",
                borderRadius: rem(2),
              },
              "& .cnt": {
                fontSize: rem(13),
                marginTop: rem(8),
              },
            },
          },
          "& .product-desc": {
            padding: `${rem(40)} ${rem(30)}`,
            "& + .btn-wrap": {
              padding: `0 ${rem(30)} ${rem(60)}`,
            },
          },
          "& .product-contents": {
            position: "relative",
            "& img": {
              width: "100%",
            },
            "& .btn-wrap": {
              position: "inherit",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-end",
              bottom: 0,
              width: "100%",
              height: rem(226),
              padding: `${rem(40)} ${rem(30)} ${rem(60)} ${rem(30)}`,
              backgroundColor: "white",
              // "& .collapse-btn": { color: "#000000" },
              "& .main-btn": {
                margin: `${rem(40)} 0 0`,
              },
            },
            "& .fade-box": {
              position: "absolute",
              height: rem(300),
              background: "rgb(255,255,255)",
              // background:
              //   "linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 53%, rgba(255,255,255,0) 100%)",
              background:
                "linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.9) 25%, rgba(255,255,255,1) 38%, rgba(255,255,255,1) 100%)",
            },
            "& .short-img-btn-wrap": {
              padding: `${rem(40)} ${rem(30)} ${rem(60)} ${rem(30)}`,
            },
          },
          "& .fav-btn": {
            position: "absolute",
            top: rem(15),
            right: rem(15),
            "& button": {
              minWidth: "auto",
            },
            "& img": {
              width: rem(28),
              height: rem(28),
            },
            "& span": {
              fontSize: rem(16),
              fontWeight: 800,
            },
          },
        },

        /****************************************************
        my review
        ****************************************************/
        "& .myReviewItems": {
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 111px)",
          "& .my-review-list": {
            padding: `${rem(30)} ${rem(30)} ${rem(60)} ${rem(30)}`,
            "& .my-review-item": {
              display: "flex",
              alignItems: "flex-start",
              "& .img": {
                position: "relative",
                background: "#F6F6F6",
                borderRadius: rem(10),
                width: rem(150),
                height: rem(150),
                "& .img-wrap": {
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  margin: "auto",
                  display: "flex",
                  position: "absolute",
                  maxWidth: "85%",
                  maxHeight: "85%",
                  alignItems: "center",
                  justifyContent: "center",
                  "& img": {
                    maxWidth: "100%",
                    maxHeight: "100%",
                  },
                },
              },
              "& .tit-wrap": {
                flex: 1,
                marginLeft: rem(20),
                "& .tit": {
                  fontSize: rem(14),
                  fontWeight: 700,
                  marginTop: rem(15),
                },
                "& .price": {
                  display: "flex",
                  alignItems: "center",
                  paddingTop: rem(6),
                  fontWeight: 800,
                  fontSize: rem(18),
                  "& span": {
                    fontWeight: 700,
                    fontSize: rem(14),
                    padding: `0 0 ${rem(2)} ${rem(1)}`,
                  },
                },
                "& .MuiButton-root": {
                  paddingTop: rem(16),
                  fontSize: rem(14),
                  color: palette.primary.main,
                },
              },
              "& + .my-review-item": {
                paddingTop: rem(15),
              },
            },
          },
          "& .nodata": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            margin: 0,
            height: "calc(100vh - 337px)",
          },
          "& .recommend": {
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            textAlign: "center",
            fontSize: rem(14),
            borderTop: `12px solid #F6F6F6`,
            marginTop: "auto",
            padding: `${rem(30)} ${rem(30)} ${rem(60)} `,
            "& .comment": {
              fontSize: rem(14),
              letterSpacing: "-0.2px",
              lineHeight: rem(22),
            },
            "& button": {
              marginTop: rem(20),
            },
          },
        },
        "& .reviewManagement": {
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 111px)",
          "& .review-list": {
            paddingBottom: rem(30),
            "& .review-item": {
              padding: rem(30),

              "& + .review-item": {
                borderTop: `1px solid #EEEEEE`,
              },

              "& .top": {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",

                "& .main-img": {
                  position: "relative",
                  background: "#F6F6F6",
                  borderRadius: rem(10),
                  width: rem(80),
                  height: rem(80),

                  "& .img-wrap": {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    margin: "auto",
                    display: "flex",
                    position: "absolute",
                    maxWidth: "85%",
                    maxHeight: "85%",
                    alignItems: "center",
                    justifyContent: "center",
                    "& img": {
                      maxWidth: "100%",
                      maxHeight: "100%",
                    },
                  },
                },
                "& .tit": {
                  flex: 1,
                  fontSize: rem(14),
                  fontWeight: 700,
                  lineHeight: rem(20),
                  marginLeft: rem(20),
                },
              },

              "& .content": {
                paddingTop: rem(30),
                fontSize: rem(14),
                lineHeight: rem(22),
              },
              "& .img": {
                marginTop: rem(15),
                flex: 1,
                height: rem(60),
                "& img": {
                  width: rem(60),
                  height: rem(60),
                  borderRadius: rem(10),
                  marginRight: rem(8),
                },
                "& .image-loader": {
                  marginRight: rem(8),
                  display: "inline-block",
                  "&:before": {
                    display: "none",
                  },
                },
              },
              "& .bottom": {
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                paddingTop: rem(12),
                fontSize: rem(12),
                color: "#8E8E8E",
                "& span": {
                  fontSize: rem(13),
                  fontWeight: 800,
                },
                "& .func-btn": {
                  display: "flex",
                  alignItems: "center",
                  "& img": {
                    width: rem(24),
                    height: rem(24),
                  },
                  "& button": {
                    minWidth: "rem(40)",
                    "& + button": {
                      marginLeft: rem(12),
                    },
                  },
                  "& .textBtn": {
                    "& button": {
                      display: "inline-block",
                      position: "relative",
                      minWidth: "auto",
                      fontWeight: "400",
                      fontSize: rem(14),
                      "& + button": {
                        marginLeft: rem(10),
                        paddingLeft: rem(10),
                        "&:before": {
                          top: "50%",
                          left: 0,
                          width: "1px",
                          height: "50%",
                          content: "''",
                          position: "absolute",
                          transform: "translateY(-50%)",
                          backgroundColor: palette.grey[100],
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          "& .nodata": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            margin: 0,
            height: "calc(100vh - 337px)",
          },
          "& .recommend": {
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            textAlign: "center",
            fontSize: rem(14),
            borderTop: `12px solid #F6F6F6`,
            marginTop: "auto",
            padding: `${rem(30)} ${rem(30)} ${rem(60)} `,
            "& .comment": {
              fontSize: rem(14),
              letterSpacing: "-0.2px",
              lineHeight: rem(22),
            },
            "& button": {
              marginTop: rem(20),
            },
          },
        },
        //detail
        "& .myReviewDetail": {
          "& .tit": {
            padding: rem(30),
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            "& .main-img": {
              position: "relative",
              background: "#F6F6F6",
              borderRadius: rem(10),
              width: rem(80),
              height: rem(80),
              "& .img-wrap": {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                margin: "auto",
                display: "flex",
                position: "absolute",
                maxWidth: "85%",
                maxHeight: "85%",
                alignItems: "center",
                justifyContent: "center",
                "& img": {
                  maxWidth: "100%",
                  maxHeight: "100%",
                },
              },
            },
            "& .prdc-tit": {
              flex: 1,
              fontSize: rem(14),
              fontWeight: 700,
              lineHeight: rem(20),
              marginLeft: rem(20),
            },
          },
          "& .comment": {
            "& .input-section": {
              padding: `${rem(30)} ${rem(30)} ${rem(60)} ${rem(30)}`,
              //   "& .MuiTextField-root": {
              //     "& .MuiInputBase-root": {
              //       height: rem(310),
              //       "& input": {
              //         height: rem(310),
              //       },
              //     },
              //   },
              "& .img-list": {
                display: "flex",
                justifyContent: "flex-start",
                "& .img-item": {
                  position: "relative",
                  margin: `${rem(15)} ${rem(8)} 0 0`,
                  width: rem(80),
                  height: rem(80),
                  display: "block",
                  "& img": {
                    width: rem(80),
                    height: rem(80),
                    borderRadius: rem(10),
                    marginRight: rem(8),
                  },
                  "& .img-close": {
                    position: "absolute",
                    top: rem(-3),
                    right: rem(-3),
                    maxWidth: rem(20),
                    maxHeight: rem(20),
                    minWidth: "auto",
                    "& img": {
                      width: rem(20),
                      height: rem(20),
                      margin: 0,
                    },
                  },
                },
              },
              "& .bottom-wrap": {
                paddingTop: rem(15),
                "& button": {
                  marginTop: rem(10),
                  "& img": {
                    paddingRight: rem(5),
                  },
                  "& + button": {
                    margin: `${rem(10)} 0 0 0`,
                  },
                },
              },
            },
            "& .MuiInput-root": {
              height: "100%",
            },
          },
        },

        /****************************************************
        point
        ****************************************************/
        "& .my-point": {
          padding: `${rem(30)} ${rem(20)}`,
          "& .point-card": {
            background: palette.background.paper,
            borderRadius: rem(10),
            padding: `${rem(30)} ${rem(24)} ${rem(14)}`,
            border: `1px solid ${palette.grey[100]}`,
            "& .tit": {
              display: "block",
              fontSize: rem(14),
              fontWeight: 700,
              lineHeight: rem(22),
            },
            "& .save-point": {
              display: "block",
              fontSize: rem(36),
              fontWeight: 800,
              lineHeight: rem(44),
              marginTop: rem(4),
              color: palette.primary.main,
            },
            "& .extinct-point": {
              display: "flex",
              justifyContent: "space-between",
              "& span": {
                fontSize: rem(14),
                color: palette.info.main,
              },
              "& .point-num": {
                fontWeight: 700,
                letterSpacing: "-0.2px",
              },
            },
          },
        },
        "& .point-info": {
          padding: `${rem(40)} 0 ${rem(35)}`,
          "& h2": {
            fontSize: rem(16),
            fontWeight: 800,
            padding: `0 ${rem(30)}`,
            lineHeight: rem(22),
          },
          "& .point-period": {
            display: "flex",
            justifyContent: "space-between",
            padding: `${rem(20)} ${rem(30)} ${rem(30)} ${rem(30)}`,

            "& .btn-rounded": {
              height: rem(34),
              border: `1px solid ${palette.grey[100]}`,
              color: palette.info.main,
              fontSize: rem(14),
              fontWeight: 400,
              "&.select": {
                border: `1px solid ${palette.primary.main}`,
                background: palette.primary.main,
                color: palette.common.white,
                fontWeight: 800,
              },
              "& + .btn-rounded": {
                marginLeft: rem(5),
              },
            },
          },
        },
        "& .type-select": {
          "& .MuiBox-root": {
            alignItems: "center",
            padding: `0 ${rem(30)}`,
            "& .MuiButton-text": {
              fontSize: rem(16),
              fontWeight: 700,
              minWidth: "auto",
            },
            "& .srch-period": {
              fontSize: rem(13),
              color: palette.info.main,
              "& b": {
                display: "inline--block",
                fontWeight: 700,
                marginRight: rem(6),
              },
              "& span": {
                letterSpacing: "-0.2px",
              },
            },
          },
        },
        "& .point-list": {
          marginTop: rem(20),
          "& li": {
            display: "flex",
            justifyContent: "space-between",
            padding: `${rem(24)} ${rem(30)}`,
            borderTop: `1px solid ${palette.grey[100]}`,
            "& .check-point": {
              "& dt": {
                fontSize: rem(15),
                fontWeight: 700,
              },
              "& dd": {
                fontSize: rem(12),
                color: palette.info.main,
                marginTop: rem(4),
                letterSpacing: "-0.2px",
              },
            },
            "& .used-point": {
              textAlign: "right",
              fontSize: rem(12),
              color: palette.info.main,
              "& b": {
                position: "relative",
                display: "block",
                fontSize: rem(15),
                fontWeight: 700,
                letterSpacing: "-0.2px",
                lineHeight: rem(20),
                paddingBottom: rem(4),
                "&.increase": {
                  color: palette.primary.main,
                  "&:before": {
                    content: "'+'",
                  },
                },
                "&.decrease": {
                  color: palette.info.main,
                  "&:before": {
                    content: "'-'",
                  },
                },
              },
            },
          },
        },
        "& .point-type": {
          "& .MuiFormControlLabel-root": {
            "& .MuiButtonBase-root": {
              marginRight: rem(15),
            },
            "& + .MuiFormControlLabel-root": {
              marginTop: rem(26),
            },
          },
        },

        /****************************************************
        setting
        ****************************************************/
        "& .setting": {
          "& .nodata": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            margin: 0,
            height: "300px",
          },
          "& .box-type-1": {
            paddingBottom: rem(40),
          },
          "& .box-type-2": {
            paddingBottom: rem(0),
          },
          "& .h-group": {
            display: "flex",
            justifyContent: "space-between",
            "& h2": {
              fontSize: rem(14),
              fontWeight: "700",
            },
            "& a, button": {
              position: "relative",
              fontSize: rem(14),
              color: palette.info.main,
              paddingRight: rem(13),
              fontWeight: 400,
              "&::after": {
                content: "''",
                position: "absolute",
                top: "50%",
                right: rem(-5),
                width: rem(18),
                height: rem(18),
                marginTop: rem(-10),
                backgroundImage: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/arrow-r-gray.svg)`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: `${rem(18)} ${rem(18)}`,
              },
            },
          },
          "& .setting-list": {
            "& li": {
              position: "relative",
              minHeight: rem(30),
              "& .tit": {
                display: "block",
                paddingTop: rem(4),
              },
              "& .cont": {
                fontSize: rem(12),
                color: palette.info.main,
                marginTop: rem(6),
              },

              "& .recipt,a": {
                position: "relative",
                display: "block",
                textDecoration: "none",
                "& .tit": {
                  color: palette.text.primary,
                },
                "&::after": {
                  content: "''",
                  position: "absolute",
                  top: "50%",
                  right: rem(-5),
                  width: rem(22),
                  height: rem(22),
                  marginTop: rem(-11),
                  backgroundImage: `url(${
                    process.env.PUBLIC_URL
                  }/images/icon/arrow-r-gray.svg)`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                },
              },
              "& .MuiSwitch-root": {
                width: rem(50),
                height: rem(30),
                position: "absolute",
                top: 0,
                right: 0,
                padding: 0,
                alignItems: "center",
                justifyContent: "center",
                "& .MuiSwitch-track": {
                  backgroundColor: "#fff",
                  border: "1px solid #eee",
                  borderRadius: rem(20),
                  boxShadow: "inset 0 1px 3px rgba(0, 0, 0, 0.13)",
                  borderRadius: rem(22),
                },
                "& .MuiSwitch-switchBase": {
                  padding: 0,
                  "& .MuiSwitch-input": {
                    width: rem(50),
                    left: 0,
                  },
                  "&.Mui-checked .MuiSwitch-input": {
                    left: "-67%",
                  },
                  "& .MuiSwitch-thumb": {
                    background: palette.common.white,
                    width: rem(26),
                    height: rem(26),
                    margin: rem(2),
                    boxShadow: "0 1px 4px rgba(134, 134, 134, 0.4)",
                  },
                  "&.Mui-checked": {
                    "& + .MuiSwitch-track": {
                      backgroundColor: palette.primary.main,
                      opacity: 1,
                      borderRadius: rem(22),
                      borderColor: palette.primary.main,
                    },
                  },
                },
              },
              "& .MuiFormControl-root": {
                marginTop: rem(20),
                "& .MuiFormControlLabel-root": {
                  marginBottom: rem(15),
                  "&:not(:last-of-type)": {
                    marginRight: rem(24),
                  },
                },
              },
              "& + li": {
                marginTop: rem(24),
              },
              "& .btn-text": {
                position: "relative",
                display: "block",
                width: "100%",
                height: rem(32),
                justifyContent: "flex-start",
                "& .tit": {
                  position: "absolute",
                  fontSize: rem(16),
                  top: 0,
                },
                "&::after": {
                  content: "''",
                  position: "absolute",
                  top: "50%",
                  right: rem(-5),
                  width: rem(22),
                  height: rem(22),
                  marginTop: rem(-11),
                  backgroundImage: `url(${
                    process.env.PUBLIC_URL
                  }/images/icon/arrow-r-gray.svg)`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                },
              },
            },
            "& .list-flex": {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              "& .tit": {
                paddingTop: 0,
              },
              "& .dec": {
                fontSize: rem(14),
                letterSpacing: "-0.2px",
                color: palette.info.main,
                "& .btn-link.underline": {
                  color: palette.primary.main,
                  borderColor: palette.primary.main,
                  "&:after": {
                    display: "none",
                  },
                },
              },
            },
          },
        },
        "& .mypagelist": {
          "& li": {
            padding: `${rem(40)} ${rem(30)}`,
            borderBottom: "1px solid #EEEEEE",
            "& a": {
              "& img": {
                marginRight: rem(20),
              },
              "& div": {
                "& .tit": {
                  fontWeight: 700,
                  lineHeight: rem(22),
                },
                "& p": {
                  marginTop: rem(4),
                  fontSize: rem(13),
                  lineHeight: rem(18),
                  marginTop: rem(4),
                },
              },
            },
          },
        },
        "& .receipt-three": {
          "& ul": {
            marginTop: "24px",
            marginLeft: "30px",
            marginBottom: "40px",
            "& li": {
              marginBottom: "20px",
              "& .a": {
                position: "relative",
                display: "block",
                textDecoration: "none",
                "& div": {
                  display: "flex",
                  justifyContent: "space-between",
                  marginRight: "50px",
                  "& .date": {
                    fontWeight: "400",
                    fontSize: "14px",
                  },
                  "& .price": {
                    fontWeight: "700",
                    fontSize: "14px",
                  },
                },
                "&::after": {
                  content: "''",
                  position: "absolute",
                  top: "50%",
                  right: rem(25),
                  width: rem(22),
                  height: rem(20),
                  marginTop: rem(-11),
                  backgroundImage: `url(${
                    process.env.PUBLIC_URL
                  }/images/icon/arrow-r-gray.svg)`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                },
              },
            },
          },
        },
        /****************************************************
        stamp
        ****************************************************/
        "& .stamp-wrap": {
          padding: `${rem(30)} ${rem(20)} ${rem(60)}`,
          "& .stamp-item": {
            // height: rem(194),
            backgroundColor: "#FFFFFF",
            borderRadius: "10px",
            padding: `${rem(35)} 0 ${rem(39)}`,
            overflow: "hidden",
            "& .header": {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: `0 ${rem(30)}`,
              "& .store": {
                fontSize: rem(13),
              },
              "& .css-cgv9rc-MuiChip-root": {
                borderColor: "#ccc",
                "& .MuiChip-label": {
                  color: "#8e8e8e",
                },
              },
              "& .MuiChip-root.MuiChip-sizeMedium": {
                borderColor: palette.grey[500],
                fontSize: rem(10),
                height: rem(18),
                padding: `${rem(3)} ${rem(8)} 0`,
                "& span": {
                  color: palette.info.main,
                },
              },
            },
            "& .title": {
              display: "flex",
              alignItems: "center",
              padding: `${rem(5)} ${rem(80)} 0 ${rem(30)}`,
              "& .text": {
                fontWeight: 700,
                wordBreak: "keep-all",
                textIndent: rem(30),
                direction: "rtl",
                textAlign: "left",
                "& .cnt": {
                  // color: theme.palette.primary.main,
                  fontSize: rem(14),
                  fontWeight: 700,
                  paddingLeft: rem(6),
                },
              },
            },
            "& .type-gauge": {
              // padding: `0 ${rem(30)}`,
              padding: `0 ${rem(24)}`,
              "& .MuiLinearProgress-root": {
                marginBottom: rem(20),
              },
            },
            "& .type-stamp": {
              display: "flex",
              overflowX: "auto",
              height: rem(54),
              margin: `${rem(19)} 0 0 ${rem(24)}`,
              // paddingRight: rem(30),

              "-ms-overflow-style": "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              "& .MuiGrid-container": {
                margin: `${rem(-9)} 0 ${rem(-9)} ${rem(-5)}`,
                width: "100%",
                flexWrap: "initial",
                justifyContent: "start",
                paddingRight: rem(30),
                "& .MuiGrid-item": {
                  flexBasis: "20%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  padding: 0,
                  margin: `${rem(9)} ${rem(5)}`,
                  "&:last-child": {
                    paddingRight: rem(24),
                    "& .benefit": {
                      marginLeft: rem(-12),
                    },
                  },
                  "& .stamp": {
                    overflow: "hidden",
                    position: "relative",
                    width: rem(54),
                    height: rem(54),
                    borderRadius: "50%",
                    // backgroundColor: palette.info.light,
                    backgroundImage: `url(${
                      process.env.PUBLIC_URL
                    }/images/icon/stamp-off.svg)`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100%",
                    "&.on": {
                      backgroundImage: `url(${
                        process.env.PUBLIC_URL
                      }/images/icon/stamp-on.svg)`,
                    },
                    "& img": {
                      width: "100%",
                    },
                  },
                  "& .benefit": {
                    position: "absolute",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50% , -50%)",
                    backgroundColor: "#BEBEBE",
                    borderRadius: rem(6),
                    lineHeight: 1,
                    color: "#F6F6F6",
                    fontSize: rem(14),
                    fontWeight: 800,
                    minWidth: rem(60),
                    minHeight: rem(23),
                  },
                  "& .date-num": {
                    position: "absolute",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    color: "#DFDFDF",
                    fontSize: rem(11),
                    fontWeight: 800,
                    lineHeight: 1,
                    "& p": {
                      fontSize: rem(17),
                      fontWeight: 800,
                      lineHeight: 1,
                    },
                    // lineHeight: rem(62),
                  },
                  "&.on": {
                    "& .stamp": {
                      overflow: "hidden",
                      position: "relative",
                      maxWidth: rem(54),
                      maxHeight: rem(54),
                      borderRadius: "50%",
                      // backgroundColor: theme.palette.info.light,
                      backgroundImage: `url(${
                        process.env.PUBLIC_URL
                      }/images/icon/stamp-on.svg)`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "100%",
                      "& img": {
                        width: "100%",
                      },
                    },
                    "& .benefit": {
                      position: "absolute",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      top: "35%",
                      left: "51%",
                      transform: "rotate(-15deg) translate(-50% , -50%)",
                      borderRadius: rem(6),
                      lineHeight: 1,
                      fontSize: rem(14),
                      fontWeight: 800,
                      backgroundColor: palette.common.white,
                      minWidth: rem(60),
                      minHeight: rem(23),
                      // margin: `${rem(9)} 0 0 ${rem(5)}`,
                    },
                  },
                },
              },
            },

            "& + .stamp-item": {
              marginTop: rem(15),
            },

            "& img": {
              height: rem(54),
              "& + img": {
                marginLeft: rem(11),
              },
            },
          },
          "& .MuiSkeleton-root + .MuiSkeleton-root": {
            marginTop: rem(15),
          },
          "& .club-tit": {
            margin: `0 0 ${rem(15)} ${rem(10)}`,
            fontSize: rem(16),
            fontWeight: 800,
          },
          "& .nodata": {
            marginTop: rem(170),
          },
        },

        /****************************************************
        payment
        ****************************************************/
        "& .Pay": {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          "& .pay-wrap": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            flex: 1,
            padding: `${rem(40)} 0 ${rem(36)}`,
            "& .card-list": {
              width: "100%",
              minHeight: rem(250),
              margin: `0 ${rem(-30)} 0 0`,
              "& .swiper-wrapper": {
                // width: "100%",
                width: rem(280),
                "& .swiper-slide-active": {
                  "& .card-item": {
                    "& .card": {
                      color: "#FFFFFF",
                      marginTop: rem(20),
                      minHeight: rem(167),
                    },
                  },
                },
              },
              "& .no-card": {
                "& .card": {
                  color: "#BEBEBE",
                  backgroundColor: "#EEEEEE",
                },
              },
              "& .card-item": {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                height: rem(200),
                "& .tit": {
                  fontSize: rem(15),
                  fontWeight: 700,
                },
                "& .card-big": {
                  marginTop: `${rem(20)} !important`,
                  minHeight: `${rem(167)} !important`,
                },
                "& .card": {
                  position: "relative",
                  width: rem(280),
                  color: "#BEBEBE",
                  backgroundColor: "#EEEEEE",
                  borderRadius: rem(14),
                  marginTop: rem(36),
                  minHeight: rem(130),
                  transition: "all ease 0.2s 0s",
                  "& .represent-badge": {
                    position: "absolute",
                    top: rem(17),
                    right: rem(-4),
                    fontSize: rem(14),
                    fontWeight: 700,
                    lineHeight: rem(22),
                    color: palette.primary.main,
                    backgroundColor: palette.common.white,
                    borderRadius: rem(4),
                    boxShadow: `0px 2px 4px rgba(0, 0, 0, 0.2)`,
                    padding: `${rem(3)} ${rem(8)} ${rem(1)} ${rem(26)}`,
                    "&::after": {
                      content: "''",
                      position: "absolute",
                      top: "50%",
                      left: rem(8),
                      width: rem(16),
                      height: rem(16),
                      marginTop: rem(-9),
                      backgroundImage: `url(${
                        process.env.PUBLIC_URL
                      }/images/icon/icon_check_red.svg)`,
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      transition: "all ease 0.5s",
                    },
                  },
                  "& .logo": {
                    position: "absolute",
                    top: rem(15),
                    left: rem(25),
                    fontSize: rem(13),
                    fontWeight: 700,
                  },
                  "& .no": {
                    position: "absolute",
                    width: "100%",
                    top: "50%",
                    left: "50%",
                    textAlign: "center",
                    transform: "translate(-50%,-50%)",
                  },
                  "& .exp": {
                    position: "absolute",
                    bottom: rem(20),
                    left: rem(25),
                    fontSize: rem(10),
                    lineHeight: 1.2,
                  },
                  "& .inf": {
                    position: "absolute",
                    bottom: rem(16),
                    right: rem(25),
                    width: rem(41),
                    height: rem(23),
                    backgroundImage: `url(${
                      process.env.PUBLIC_URL
                    }/images/icon/visa-simbol.png)`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: `${rem(41)} ${rem(23)}`,
                    textIndent: rem(-9999),
                  },
                },
                "& .btn-wrap": {
                  paddingTop: rem(15),
                  "& .MuiButton-root ": {
                    display: "inline-block",
                    position: "relative",
                    color: "#8E8E8E",
                    fontSize: rem(14),
                    fontWeight: 400,
                    "& +.MuiButton-root": {
                      paddingLeft: rem(15),
                      marginLeft: rem(15),
                      "&::before": {
                        content: "''",
                        position: "absolute",
                        top: "50%",
                        left: 0,
                        transform: "translateY(-50%)",
                        height: "50%",
                        width: "1px",
                        backgroundColor: palette.info.light,
                      },
                    },
                  },
                },
              },
            },
            "& .add-btn": {
              padding: `0 ${rem(30)}`,
              "& .MuiButton-root + .MuiButton-root": {
                margin: `${rem(10)} 0 0 0`,
              },
            },
          },
          "& .notice": {
            borderTop: "1px solid #EEEEEE",
            margin: 0,
          },
        },

        /****************************************************
        sign
        ****************************************************/
        "& .sign": {
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          "& h3": {
            padding: `${rem(30)} ${rem(30)} ${rem(20)} ${rem(30)}`,
          },
          "& .sign-wrap": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            flex: 1,
            padding: `0 ${rem(30)} ${rem(60)}`,
            "& .signature": {
              height: rem(325),
              backgroundColor: "#FFF4F2",
              borderRadius: rem(10),
            },
            "& .btn-wrap": {
              "& .MuiButton-root": {
                width: "100%",
                "& +.MuiButton-root": {
                  width: "100%",
                  marginTop: rem(10),
                  marginLeft: 0,
                },
              },
            },
          },
        },
        /****************************************************
        App Card
        ****************************************************/

        "& .AppCard": {
          "& .drawer-head": {
            padding: `${rem(10)} !important`,
            borderBottom: "none !important",
          },
          "& .drawer-body": {
            overflowX: "hidden",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            "& .point-section": {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              padding: rem(40),
              minHeight: rem(256),
              maxHeight: rem(256),
              "& .cnt": {
                position: "relative",
                fontSize: rem(38),
                fontWeight: 800,
                marginTop: rem(20),
                lineHeight: rem(44),
                minWidth: "auto",
                "&:after": {
                  content: "''",
                  position: "absolute",
                  top: rem(8),
                  right: rem(-22),
                  width: rem(22),
                  height: rem(22),
                  backgroundImage: `url(${
                    process.env.PUBLIC_URL
                  }/images/icon/add.svg)`,
                  backgroundRepeat: "no-repeat",
                },
              },
              "& .barcode": {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                "& svg": {
                  width: "65%",
                  height: "auto",
                  marginTop: rem(5),
                },
                "& .barcode-number": {
                  bottom: 0,
                  fontSize: rem(12),
                  marginTop: rem(2),
                },
              },
            },
            "& .card-section": {
              width: "100%",
              padding: `${rem(40)} 0 ${rem(47)} `,
              borderTop: "12px solid #F6F6F6",
              "& .card-list": {
                width: "100%",
                minHeight: rem(236),
                margin: `0 ${rem(-30)} 0 0`,
                padding: 0,
                "& .swiper-wrapper": {
                  // width: "100%",
                  width: rem(280),
                  "& .swiper-slide-active": {
                    "& .card-item": {
                      "& .card": {
                        color: "#FFFFFF",
                        marginTop: rem(20),
                        minHeight: rem(167),
                      },
                    },
                  },
                },
                "& .no-card": {
                  "& .card": {
                    color: "#BEBEBE",
                    backgroundColor: "#EEEEEE",
                  },
                },
                "& .card-item": {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  height: rem(200),
                  "& .tit": {
                    fontSize: rem(15),
                    fontWeight: 700,
                  },
                  "& .card-big": {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: `${rem(20)} !important`,
                    minHeight: `${rem(167)} !important`,
                    border: `1px solid #DFDFDF`,
                    borderRadius: rem(10),
                  },
                  "& .card": {
                    position: "relative",
                    width: rem(280),
                    color: "#FFFFFF",
                    borderRadius: rem(20),
                    marginTop: rem(36),
                    minHeight: rem(130),
                    transition: "all ease 0.2s 0s",
                    "& .logo": {
                      position: "absolute",
                      top: rem(15),
                      left: rem(25),
                      fontSize: rem(13),
                      fontWeight: 700,
                    },
                    "& .no": {
                      position: "absolute",
                      width: "100%",
                      top: "50%",
                      left: "50%",
                      textAlign: "center",
                      transform: "translate(-50%,-50%)",
                    },
                    "& .exp": {
                      position: "absolute",
                      bottom: rem(20),
                      left: rem(25),
                      fontSize: rem(10),
                      lineHeight: 1.2,
                    },
                    "& .inf": {
                      position: "absolute",
                      bottom: rem(16),
                      right: rem(25),
                    },
                    "& .plus-btn": {
                      flexDirection: "column",
                      width: "100%",
                      height: "100%",
                      fontSize: rem(14),
                      "& img": {
                        width: rem(24),
                        height: rem(24),
                        marginBottom: rem(5),
                      },
                    },
                  },
                  "& .btn-wrap": {
                    paddingTop: rem(15),
                    "& .MuiButton-root ": {
                      display: "inline-block",
                      position: "relative",
                      color: "#8E8E8E",
                      fontSize: rem(14),
                      fontWeight: 400,
                      "& +.MuiButton-root": {
                        paddingLeft: rem(15),
                        marginLeft: rem(15),
                        "&::before": {
                          content: "''",
                          position: "absolute",
                          top: "50%",
                          left: 0,
                          transform: "translateY(-50%)",
                          height: "50%",
                          width: "1px",
                          backgroundColor: palette.info.light,
                        },
                      },
                    },
                  },
                },
              },
              "& .MuiSwitch-root": {
                width: rem(95),
                height: rem(30),
                padding: 0,
                alignItems: "center",
                justifyContent: "center",
                overflow: "visible",
                background: palette.background.default,
                borderRadius: rem(22),
                "& .MuiSwitch-track": {
                  position: "relative",
                  backgroundColor: "#fff",
                  border: "none",
                  boxShadow: "none",
                  borderRadius: rem(22),
                  "&:before, &:after": {
                    position: "absolute",
                    top: rem(6),
                    fontSize: rem(13),
                    letterSpacing: "-0.2px",
                    fontWeight: 700,
                    color: palette.text.disabled,
                  },
                  "&:before": {
                    content: "'OFF'",
                    left: rem(13),
                  },
                  "&:after": {
                    content: "'ON'",
                    right: rem(14),
                  },
                },
                "& .MuiSwitch-switchBase": {
                  padding: 0,
                  "& .MuiSwitch-thumb": {
                    position: "relative",
                    background: "#9e9e9e",
                    width: rem(47),
                    height: rem(30),
                    margin: 0,
                    boxShadow: "0 2px 2px rgba(158, 158, 158, 0.3)",
                    borderRadius: rem(22),
                    "&:after": {
                      position: "absolute",
                      top: rem(6),
                      fontSize: rem(13),
                      letterSpacing: "-0.2px",
                      fontWeight: 700,
                      color: palette.common.white,
                      content: "'OFF'",
                      right: rem(14),
                    },
                  },
                  "& + .MuiSwitch-track": {
                    opacity: 1,
                    background: palette.background.default,
                  },
                  "&.Mui-checked": {
                    transform: "translateX(49px)",
                    "& .MuiSwitch-thumb": {
                      background: palette.primary.main,
                      "&:after": {
                        content: "'ON'",
                      },
                    },
                    // "& + .MuiSwitch-track": {
                    //   background: palette.common.white,
                    // },
                  },
                },
              },
              "& .list-dot": {
                padding: `0 ${rem(40)} 0 ${rem(40)}`,
              },
            },
          },
        },
        /****************************************************
        coupon
        ****************************************************/
        "& .coupon-list": {
          "& .coupon-item": {
            border: `1px solid ${palette.grey[100]}`,
            backgroundColor: palette.common.white,
            borderRadius: rem(10),
            height: rem(178),
            "& .item-wrap": {
              position: "relative",
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              height: rem(178),
              top: 0,
              left: 0,
              padding: `${rem(25)} ${rem(22)} ${rem(26)} ${rem(30)}`,
              "& .divider": {
                display: "none",
              },
              "& .contents": {
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                paddingRight: rem(20),
                flex: 1,
                width: "calc(100% - 50px)",
                "& .dday": {
                  padding: `0 ${rem(6)}`,
                },
                "& .autoApp": {
                  borderColor: palette.action.disabled,
                  padding: `0 ${rem(6)}`,
                },
                "& .tit": {
                  fontSize: rem(22),
                  fontWeight: 700,
                  paddingTop: rem(12),
                  lineHeight: rem(28),
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  "-webkit-box-orient": "vertical",
                },
                "& .tit-sub": {
                  fontSize: rem(13),
                  color: palette.info.main,
                  paddingTop: rem(5),
                  lineHeight: rem(18),
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  wordWrap: "break-word",
                  "-webkit-line-clamp": 2,
                  "-webkit-box-orient": "vertical",
                },
                "& .date": {
                  fontSize: rem(12),
                  color: palette.info.main,
                  lineHeight: rem(18),
                  letterSpacing: "-0.2px",
                },
                "& .divider": {
                  display: "none",
                },
                "& .chip-area": {
                  height: rem(16),
                  "& .MuiChip-root": {
                    verticalAlign: "top",
                    lineHeight: rem(16),
                    height: rem(16),
                    "& + .MuiChip-root": {
                      marginLeft: rem(4),
                    },
                  },
                },
              },
              "& .side": {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: `${rem(25)} 0`,
                paddingLeft: rem(22),
                backgroundImage:
                  "linear-gradient(to bottom, #ccc 40%, rgba(255, 255, 255, 0) 20%)",
                backgroundPosition: "left",
                backgroundSize: "1px 7px",
                backgroundRepeat: "repeat-y",
                flexBasis: rem(50),
                "& .MuiButton-text": {
                  minWidth: "auto",
                },
              },
              "&:before": {
                display: "block",
                content: "''",
                width: rem(16),
                height: rem(8),
                borderWidth: "0 1px 1px 1px",
                borderStyle: "solid",
                borderRadius: `${rem(0)} ${rem(0)} ${rem(8)} ${rem(8)}`,
                position: "absolute",
                right: rem(62),
                top: rem(-1),
                background: "#f6f6f6",
                borderColor: palette.grey[100],
              },
              "&:after": {
                display: "block",
                content: "''",
                width: rem(16),
                height: rem(8),
                borderWidth: "1px 1px 0 1px",
                borderStyle: "solid",
                borderRadius: `${rem(8)} ${rem(8)} ${rem(0)} ${rem(0)}`,
                position: "absolute",
                right: rem(62),
                bottom: rem(0),
                background: "#f6f6f6",
                borderColor: palette.grey[100],
              },
            },
            "& + .coupon-item": {
              marginTop: rem(15),
            },
          },
        },
        /****************************************************
        push list
        ****************************************************/
        "& .PushList": {
          "& .push-item": {
            position: "relative",
            padding: `${rem(37)} ${rem(30)} ${rem(30)} ${rem(78)}`,
            "& .icon-notice": {
              position: "absolute",
              top: rem(30),
              left: rem(30),
              width: rem(38),
              height: rem(38),
              backgroundImage: `url(${
                process.env.PUBLIC_URL
              }/images/icon/push-notice.svg)`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            },
            "& .icon-event": {
              position: "absolute",
              top: rem(30),
              left: rem(30),
              width: rem(38),
              height: rem(38),
              backgroundImage: `url(${
                process.env.PUBLIC_URL
              }/images/icon/push-event.svg)`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            },
            "& .h2": { lineHeight: rem(24) },
            "& .cont": {
              paddingTop: rem(10),
              fontSize: rem(13),
            },
            "& .date": {
              paddingTop: rem(10),
              fontSize: rem(12),
              color: palette.info.main,
            },
            "& .link": {
              position: "absolute",
              top: rem(38),
              right: rem(30),
              width: rem(22),
              height: rem(22),
              backgroundImage: `url(${
                process.env.PUBLIC_URL
              }/images/icon/arrow-r-gray.svg)`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            },
          },
          "& .push-info": {
            textAlign: "center",
            padding: `${rem(30)} ${rem(30)} ${rem(60)} `,
          },

          "& .nodata-wrap": {
            display: "flex",
            minHeight: "calc(100vh - 52px)",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
          },
        },

        /****************************************************
        popup
        ****************************************************/
        "& .out-btn .MuiDrawer-paper": {
          overflow: "visible",
          "& .swiper-container": {
            borderTopLeftRadius: rem(30),
            borderTopRightRadius: rem(30),
          },
          "& .drawer-out-btn": {
            position: "absolute",
            top: rem(-34),
            left: 0,
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            padding: `0 ${rem(30)}`,
            "& button": {
              fontSize: rem(14),
              color: "#fff",
              minWidth: "auto",
              lineHeight: rem(22),
              fontWeight: 400,
            },

            "& .btn-days-hidden": {
              position: "relative",
              paddingLeft: rem(24),
              "&:before": {
                content: "''",
                position: "absolute",
                left: 0,
                top: 0,
                width: rem(20),
                height: rem(20),
                backgroundImage: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/close-pop-white.svg)`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              },
            },
            "& .btn-out-closed": {},
          },
        },

        /****************************************************
        favorite store
        ****************************************************/
        "& .favoriteStore": {
          "& .type-select": {
            padding: `${rem(20)} ${rem(30)}`,
            borderBottom: "1px solid #EEEEEE",
            "& .MuiBox-root": {
              padding: 0,
              "& .MuiButton-text": {
                lineHeight: rem(22),
                "& .ico-filter": {
                  marginBottom: rem(2),
                },
              },
            },
          },
          "& .store-list": {
            "& .store-item": {
              position: "relative",
              padding: rem(30),
              borderBottom: "1px solid #EEEEEE",
              "& h3": {
                fontSize: rem(18),
                fontWeight: 700,
              },
              "&:last-child": {
                borderBottom: "none",
                paddingBottom: rem(60),
              },
              "& .time-table": {
                marginTop: rem(10),
                color: "#8E8E8E",
                fontSize: rem(14),
                width: "100%",
                textAlign: "left",
                tableLayout: "fixed",
                "& th": {
                  lineHeight: rem(22),
                  minWidth: rem(36),
                  width: rem(63),
                  verticalAlign: "top",
                  paddingTop: rem(5),
                },
                "& td": {
                  lineHeight: rem(22),
                  wordBreak: "keep-all",
                  padding: `${rem(5)} ${rem(30)} 0 0`,
                },
              },
              "& .MuiChip-root": {
                marginLeft: rem(6),
                padding: `${rem(2)} ${rem(6)}`,
                height: rem(18),
                lineHeight: rem(18),
                "&.disableChip": {
                  background: "#bebebe",
                },
                "&.blackChip": {
                  background: "#000",
                },
                "& .MuiChip-label": {
                  fontWeight: 400,
                },
              },
              "& .location": {
                width: "90%",
                fontSize: rem(15),
                paddingTop: rem(10),
                lineHeight: rem(20),
              },
              "& button": {
                position: "absolute",
                minWidth: rem(22),
                right: rem(30),
                top: rem(33),
              },
            },
          },
        },
        "& .favoriteStoreDetail": {
          "& .store-info": {
            padding: `${rem(30)} ${rem(30)} ${rem(50)}`,
            "& .tit": {
              position: "relative",
              fontSize: rem(22),
              fontWeight: 800,
              "& .MuiChip-root": {
                marginLeft: rem(6),
                padding: `${rem(2)} ${rem(6)}`,
                height: rem(18),
                lineHeight: rem(18),
                "&.disableChip": {
                  background: "#bebebe",
                },
                "&.blackChip": {
                  background: "#000",
                },
                "& .MuiChip-label": {
                  fontWeight: 400,
                },
              },
              "& button": {
                position: "absolute",
                minWidth: rem(22),
                top: "50%",
                right: 0,
                transform: "translateY(-50%)",
              },
            },
            "& .info-table": {
              margin: `${rem(30)} 0 ${rem(30)} ${rem(28)}`,
              textAlign: "left",
              "& tr": {
                display: "flex",
                flexDirection: "column",
                lineHeight: rem(30),
                "& + tr": { marginTop: rem(20) },
                "& th": {
                  fontWeight: 700,
                  lineHeight: rem(22),
                },
                "& td": {
                  fontSize: rem(14),
                  lineHeight: rem(22),
                  padding: `${rem(10)} ${rem(30)} 0 0`,
                  wordBreak: "keep-all",
                  "& .info-txt": {
                    paddingLeft: rem(8),
                    fontSize: rem(13),
                  },
                },
              },
              "& .time": {
                position: "relative",
                "&::after": {
                  content: "''",
                  position: "absolute",
                  top: rem(0),
                  left: rem(-28),
                  width: rem(22),
                  height: rem(22),
                  backgroundImage: `url(${
                    process.env.PUBLIC_URL
                  }/images/icon/clock-black.svg)`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                },
              },
              "& .calendar": {
                position: "relative",
                "&::after": {
                  content: "''",
                  position: "absolute",
                  top: rem(0),
                  left: rem(-28),
                  width: rem(22),
                  height: rem(22),
                  backgroundImage: `url(${
                    process.env.PUBLIC_URL
                  }/images/icon/calendar.svg)`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                },
              },
              "& .location": {
                position: "relative",
                "&::after": {
                  content: "''",
                  position: "absolute",
                  top: rem(0),
                  left: rem(-28),
                  width: rem(22),
                  height: rem(22),
                  backgroundImage: `url(${
                    process.env.PUBLIC_URL
                  }/images/icon/location.svg)`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                },
              },
              "& .call": {
                position: "relative",
                "&::after": {
                  content: "''",
                  position: "absolute",
                  top: rem(0),
                  left: rem(-28),
                  width: rem(22),
                  height: rem(22),
                  backgroundImage: `url(${
                    process.env.PUBLIC_URL
                  }/images/icon/call.svg)`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                },
              },
            },
          },
          "& .divider": {
            height: rem(12),
            backgroundColor: "#F6F6F6",
          },
          "& .MuiTabs-root": {
            marginTop: rem(25),
          },
          "& .find-btn": {
            textAlign: "center",
            padding: `0 0 ${rem(60)} 0`,
          },
        },
        /****************************************************
        sidebar
        ****************************************************/
        "& .sidebar": {
          "& .box-type-1": {
            padding: `${rem(40)} ${rem(40)} ${rem(50)} ${rem(40)}`,
          },
          "& .header": {
            position: "fixed",
            backgroundColor: palette.primary.main,
            color: palette.common.white,
            padding: `${rem(30)} ${rem(30)} ${rem(30)} ${rem(59)}`,
            fontSize: rem(14),
            lineHeight: rem(22),
            width: "inherit",
            top: 0,
            zIndex: 1,
            // "&:before": {
            //   content: '""',
            //   display: "block",
            //   position: "absolute",
            //   width: rem(22),
            //   height: rem(22),
            //   left: rem(30),
            //   // top: "50%",
            //   // transform: "translate(-50%,-50%)",
            //   backgroundImage: `url(${
            //     process.env.PUBLIC_URL
            //   }/images/icon/white-sm-logo.svg)`,
            //   backgroundRepeat: "no-repeat",
            //   backgroundSize: "100% auto",
            // },
            "& img": { width: rem(22), height: rem(22), marginRight: rem(8) },
            "& .login": {
              fontSize: rem(14),
              fontWeight: 700,
              color: palette.common.white,
              textDecoration: "underline",
              textUnderlinePosition: "under",
            },
            "& .my-info": {
              position: "relative",
              fontSize: rem(16),
              fontWeight: 700,
              color: palette.common.white,
              "&:after": {
                content: '""',
                display: "block",
                position: "absolute",
                width: rem(20),
                height: rem(20),
                right: rem(-21),
                top: "50%",
                transform: "translateY(-50%)",
                backgroundImage: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/go-white.svg)`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% auto",
              },
            },
          },
          "& .MuiDrawer-paper": {
            width: "92vw",
            // paddingBottom: rem(94),
            paddingTop: rem(82),
          },
          "& .category-box": {
            "& h4": {
              position: "relative",
              marginBottom: rem(5),
              fontSize: rem(16),
              fontWeight: 800,
              color: palette.primary.main,
              paddingLeft: rem(10),
              "&::before": {
                content: "''",
                position: "absolute",
                top: "50%",
                left: 0,
                height: rem(4),
                width: rem(4),
                marginTop: rem(-2),
                borderRadius: "50%",
                backgroundColor: palette.primary.main,
              },
            },
            "& .MuiGrid-root": {
              margin: `${rem(5)} 0 0`,
              width: "100%",
              "& .MuiGrid-item": {
                marginTop: rem(25),
                padding: 0,
                "& > a, & > button": {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  // height: rem(54),
                  width: "100%",
                },
                "& .img": {
                  overflow: "hidden",
                  width: rem(52),
                  height: rem(52),
                  borderRadius: "50%",
                  // backgroundColor: palette.info.main,
                  "& img": {
                    width: "100%",
                    height: "100%",
                  },
                },
                "& .img-fixed": {
                  overflow: "hidden",
                  position: "relative",
                  width: rem(28),
                  minHeight: rem(28),
                  "& img": {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  },
                },
                "& .nm": {
                  display: "inline-block",
                  marginTop: rem(8),
                  fontSize: rem(13),
                  // fontWeight: 700,
                  fontWeight: 400,
                  textAlign: "center",
                  lineHeight: rem(18),
                },

                // "& + .MuiGrid-item": {
                //   paddingLeft: rem(15),
                // },
              },
            },
          },
          "& .category-box-club": {
            "& h4": {
              position: "relative",
              marginBottom: rem(5),
              fontSize: rem(16),
              fontWeight: 800,
              color: palette.primary.main,
              paddingLeft: rem(10),
              "&::before": {
                content: "'·'",
                position: "absolute",
                top: 0,
                left: 0,
                height: "100%",
                width: "100%",
                color: palette.primary.main,
              },

              "& .link": {
                position: "relative",
                fontSize: rem(16),
                fontWeight: 800,
                minWidth: "auto",
                lineHeight: rem(24),
                color: palette.primary.main,
                "&::after": {
                  position: "absolute",
                  content: "''",
                  width: rem(20),
                  height: rem(20),
                  top: rem(2),
                  left: rem(29),
                  backgroundImage: `url(${
                    process.env.PUBLIC_URL
                  }/images/icon/go.svg)`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundSize: `${rem(20)} ${rem(20)}`,
                },
              },
            },
            "& .MuiGrid-root": {
              "& .MuiGrid-item": {
                marginTop: rem(25),
                height: rem(78),
                "& > a, & > button": {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  height: rem(54),
                  width: "100%",
                },
                "& .img": {
                  overflow: "hidden",
                  // backgroundColor: palette.info.main,
                  "& img": {
                    width: "100%",
                    height: "100%",
                  },
                },
                "& .img-fixed": {
                  overflow: "hidden",
                  position: "relative",
                  width: rem(28),
                  minHeight: rem(28),
                  "& img": {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  },
                },
                "& .nm": {
                  display: "inline-block",
                  marginTop: rem(8),
                  fontSize: rem(13),
                  // fontWeight: 700,
                  textAlign: "center",
                },

                // "& + .MuiGrid-item": {
                //   paddingLeft: rem(15),
                // },
              },
            },
          },
          "& .foot-actions": {
            // position: "fixed",
            // bottom: "0",
            width: "inherit",
            "& .MuiDivider-root": {
              borderColor: "#F6F6F6",
              borderBottomWidth: rem(12),
            },
            "& .MuiGrid-root": {
              margin: 0,
              width: "100%",
              height: rem(82),
              backgroundColor: palette.common.white,
              padding: `0 ${rem(15)}`,
              "& .MuiGrid-item": {
                display: "flex",
                position: "relative",
                alignItems: "center",
                justifyContent: "center",
                flex: 1,
                paddingTop: "0",
                textAlign: "center",
                "& a, button": {
                  display: "inline-block",
                  padding: `${rem(10)} ${rem(5)}`,
                  fontSize: rem(14),
                  fontWeight: 700,
                },
                "& + .MuiGrid-item": {
                  "&::before": {
                    content: "''",
                    position: "absolute",
                    top: "50%",
                    left: 0,
                    transform: "translateY(-50%)",
                    height: rem(13),
                    width: "1px",
                    backgroundColor: palette.info.light,
                  },
                },
              },
            },
          },
          "& .btn-close": {
            position: "absolute",
            top: rem(29),
            right: rem(20),
            width: rem(24),
            height: rem(24),
            backgroundImage: `url(${
              process.env.PUBLIC_URL
            }/images/icon/close-white.svg)`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            borderRadius: 0,
          },
          "& .btn-home": {
            position: "absolute",
            top: rem(30),
            left: rem(30),
            width: rem(22),
            height: rem(22),
            backgroundImage: `url(${
              process.env.PUBLIC_URL
            }/images/icon/white-sm-logo.svg)`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            borderRadius: 0,
          },
          "& .btn-push-off": {
            position: "absolute",
            top: rem(29),
            right: rem(61),
            width: rem(26),
            height: rem(26),
            backgroundImage: `url(${
              process.env.PUBLIC_URL
            }/images/icon/push_off.svg)`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            borderRadius: 0,
          },
          "& .btn-push-on": {
            position: "absolute",
            top: rem(29),
            right: rem(61),
            width: rem(26),
            height: rem(26),
            backgroundImage: `url(${
              process.env.PUBLIC_URL
            }/images/icon/push_on.svg)`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            borderRadius: 0,
          },
        },
        /****************************************************
        mypage
        ****************************************************/

        "& .setting .shopping-info.setting-list li .tit": {
          paddingTop: 0,
        },

        /****************************************************
        editor popup
        ****************************************************/
        "& .layerPop": {
          display: "flex",
          opacity: 0,
          position: "fixed",
          right: 0,
          bottom: 0,
          top: 0,
          left: 0,
          background: "rgba(0,0,0,.5)",
          alignItems: "center",
          justifyContent: "center",
          transition: "all .3s",
          zIndex: "-1",
          "& .dialog": {
            width: "100vw",
            margin: "32px",
            borderRadius: "30px",
            background: "#fff",
            boxShadow:
              "0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%)",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            maxHeight: "calc(100% - 64px)",
            maxWidth: "600px",
            overflow: "hidden",
            zIndex: 2,
            "& h2": {
              padding: `${rem(30)} 0 0 0`,
              fontSize: rem(18),
              textAlign: "center",
              fontWeight: "700",
            },
            "& .dialog-content": {
              padding: `${rem(30)} ${rem(40)}`,
              lineHeight: rem(22),
              flex: "1 1 auto",
              color: "#000",
              fontSize: rem(15),
              textAlign: "center",
            },
            "& .dialog-btn": {
              height: rem(55),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "& button": {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                outline: 0,
                border: 0,
                width: "100%",
                height: "100%",
                fontSize: rem(16),
                fontWeight: 700,
                minWidth: "64px",
                color: "#fff",
                "&.btn-cancel": {
                  backgroundColor: "#ccc",
                },
                "&.btn-confirm": {
                  backgroundColor: "#F1270B",
                },
              },
            },
          },
        },
      },
    },
  })(() => null);

  return <CommonCss />;
}

export default Common;
